module.exports = __webpack_public_path__ + "img/brookfield_multiplex.7beaddad.jpg";